<template>
    <div class="wrapper fv">
        <a-spin :spinning="loading">
            <span v-if="itemData && itemData">
                <!-- <ArticleDetail :_itemData="itemData" :_treeData="treeData" :_relatedData="data"></ArticleDetail> -->
                <div class="w">
                    <div :class="device === 'mobile' ? 'part1_mobile' : 'part1'">
                        <div class="title">
                            <h2>
                                {{itemData.name}}
                            </h2>
                            <div class="extra-part1">
                                <span>{{itemData.timestamp.substring(0, 10)}}</span>
                                <span style="margin-left: 10px;">{{itemData.section.name}}</span>
                                <span style="margin-left: 10px;">
                                    <a-icon type="eye" />
                                    {{itemData.hits}}
                                </span>
                            </div>
                            <div class="extra-part2">
                                <fc-tag :_tags="itemData.tags" :_isShowMode="true"></fc-tag>
                            </div>
                        </div>
                        <a-divider />
                        <div class="body">
                            <div class="html-body" v-html="itemData.detail" />
                        </div>
                        <a-divider />
                        <div class="concact">
                            <div class="concact-card">
                                <div style="padding: 20px;"><strong style="font-size: 28px;">联系我们</strong></div>
                                <a-list :grid="grid" :data-source="concactData">
                                    <a-list-item slot="renderItem" slot-scope="item, index">
                                        <a-card hoverable class="item-card">
                                            <a-card-meta>
                                                <template slot="title">
                                                    <a-icon :type="item.icon" style="font-size: 70px; color: #0a5495 !important;" />
                                                    <br/>
                                                    <br/>
                                                    <strong style="font-size: 24px;">{{item.title}}</strong>
                                                </template>
                                                <template slot="description">
                                                    <span style="font-size: 18px;">{{item.description}}</span>
                                                    <a-divider />
                                                    <span v-if="item.icon==='mail'" >
                                                        <a :href="'mailto:'+item.detail" style="font-size: 20px; color: #0a5495 !important;">{{item.detail}}</a>
                                                    </span>
                                                    <span v-if="item.icon==='phone'">
                                                        <a :href="'tel:'+item.detail" style="font-size: 20px; color: #0a5495 !important;">{{item.detail}}</a>
                                                    </span>
                                                    <!-- <span style="font-size: 20px; color: #0a5495 !important;">{{item.detail}}</span> -->
                                                </template>
                                            </a-card-meta>
                                        </a-card>
                                    </a-list-item>
                                </a-list>
                            </div>
                            <div class="concact-form">
                                <div style="padding: 20px;"><strong style="font-size: 28px;">留下您的信息</strong></div>
                                <div class="form-card">
                                    <span style="font-size: 18px;">对我们的服务感兴趣，希望获取更多技术细节，<br/>欢迎随时留言</span>
                                    <div ref="SUBMIT_TIPS" style="">{{submitTips}}</div>
                                    <a-form-model
                                        ref="FORM"
                                        :model="form"
                                        :rules="rules"
                                    >
                                        <a-form-model-item ref="name" prop="name">
                                            <a-input placeholder="称呼"
                                                v-model="form.name"
                                                size="large"
                                                @blur="
                                                () => {
                                                    $refs.name.onFieldBlur();
                                                }
                                                "
                                            />
                                        </a-form-model-item>
                                        <a-form-model-item ref="description" prop="description">
                                            <a-textarea placeholder="描述您关心的，需要咨询我们的问题；如果您没有想好，可以跳过"
                                                v-model="form.description"
                                                size="large"
                                                :rows="5"
                                                @blur="
                                                () => {
                                                    $refs.description.onFieldBlur();
                                                }
                                                "
                                            />
                                        </a-form-model-item>
                                        <a-form-model-item ref="phone" prop="phone">
                                            <a-input placeholder="电话，手机 或 微信号"
                                                v-model="form.phone"
                                                size="large"
                                                @blur="
                                                () => {
                                                    $refs.phone.onFieldBlur();
                                                }
                                                "
                                            />
                                        </a-form-model-item>
                                        <a-form-model-item ref="email" prop="email">
                                            <a-input placeholder="邮件，非必填项"
                                                v-model="form.email"
                                                size="large"
                                                @blur="
                                                () => {
                                                    $refs.email.onFieldBlur();
                                                }
                                                "
                                            />
                                        </a-form-model-item>
                                        <a-form-model-item>
                                            <a-button type="primary" block size="large" @click="onSubmit">
                                                提交
                                            </a-button>
                                        </a-form-model-item>
                                    </a-form-model>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :class="device === 'mobile' ? 'part2_mobile' : 'part2'">
                        <h3>更多推荐</h3>
                        <a-list item-layout="horizontal" :pagination="pagination" :data-source="data">
                            <a-list-item slot="renderItem" slot-scope="item, index" @click="() => onClickRelated(item.key)">
                                <a-list-item-meta>
                                    <a slot="title" class="list-item-title" >{{ item.name }}</a>
                                    <template slot="description">
                                        <!-- <div class="list-item-description">
                                            {{item.description}}
                                        </div> -->
                                        <!-- <a-divider /> -->
                                        <!-- <div class="list-item-tags">
                                            <fc-tag :_tags="item.tags" :_isShowMode="true" _color="blue"></fc-tag>
                                        </div> -->
                                        <div class="list-item-time">
                                            {{item.timestamp.substring(0, 10)}}
                                        </div>
                                    </template>
                                    <!-- <a-avatar
                                        slot="avatar"
                                        :src="item.images[0]"
                                    /> -->
                                    <img
                                        slot="avatar"
                                        :alt="item.name"
                                        :src="item.images[0]"
                                        class="list-item-avatar"
                                    />
                                </a-list-item-meta>
                            </a-list-item>
                        </a-list>
                    </div>
                </div>
            </span>
        </a-spin>
    </div>
</template>

<script>
    import FcTag from '@/components/fc-tag'
    import { collectionAdd } from '@/api/collection';
    import { sectionList, sectionAdd, sectionUpdate, sectionDel, sectionTree } from '@/api/section';
    import { articleList, articleAdd, articleUpdate, articleDel, articleQuery, articleHit } from '@/api/article';
    import { queryArticle } from '@/api/query';
    
    const { head, body } = document;

    const data = [];
    export default {
        components: {
            FcTag,
        },
        computed: {
            device() {
                return this.$store.state.app.device;
            },
            grid() {
                var column = Math.ceil(this.clientRect.width / 540);
                return { gutter: 16, column: Math.min(Math.max(1, column), 2) };
            }
        },
        watch: {
            // 监听 相同路由不同参数间的 跳转
            '$route' (to, from) {
                // data数据操作
                let d = {
                    'pageNo': 1,
                    'pageSize': 1,
                    'guid': this.$route.query.articleId,
                }
                this.detailArticle(d);
            }
        },
        data() {
            this.cacheData = data.map(item => ({
                ...item
            }));
            return {
                loading: false,
                data,
                itemData: undefined,
                treeData: {
                    sectionData: [],
                },
                concactData: [
                    {
                        'title': '邮件',
                        'icon': 'mail',
                        'description': '我们将尽快回复您',
                        'detail': 'partner@beebybees.com'
                    },
                    {
                        'title': '电话',
                        'icon': 'phone',
                        'description': '周一 ~ 周日 09:00 - 18:00',
                        'detail': '18980661357'
                    }
                ],
                submitTips: '',
                form: {
                    name: '',
                    description: '',
                    email: '',
                    phone: '',
                },
                rules: {
                    name: [
                        { required: true, message: '请填写', trigger: 'blur' },
                        { min: 1, max: 127, message: '我们该如何称呼您', trigger: 'blur' },
                    ],
                    description: [
                        { required: false, message: '请填写', trigger: 'blur' },
                        { min: 1, max: 512, message: '请填写您关心的问题', trigger: 'blur' },
                    ],
                    email: [
                        { required: false, message: '请填写', trigger: 'blur' },
                        { min: 3, max: 255, message: '请填写正确的邮件地址', trigger: 'blur' },
                    ],
                    phone: [
                        { required: true, message: '请填写', trigger: 'blur' },
                        { min: 11, max: 18, message: '请填写正确的电话号码', trigger: 'blur' },
                    ],
                },
                pagination: {
                    onChange: page => {
                        console.log(page);
                        this.pagination.pageNo = page;
                        this.queryArticles();
                    },
                    pageNo: 1,
                    pageSize: 5,
                    total: 0,
                },
                clientRect: body.getBoundingClientRect(),
            };
        },
        beforeMount() {
            window.addEventListener('resize', this.$_resizeHandler)
        },
        created() {
            this.treeSections();
            let d = {
                'pageNo': 1,
                'pageSize': 1,
                'guid': this.$route.query.articleId,
            }
            this.detailArticle(d);
            let h = {
                'guid': this.$route.query.articleId,
            }
            this.hitArticle(h);
        },
        mounted() {
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.$_resizeHandler)
        },
        methods: {
            $_resizeHandler() {
                this.clientRect = body.getBoundingClientRect();
            },
            configTDK(tdk) {
                document.title = tdk.title;
                document.querySelector('meta[name="description"]').setAttribute('content', tdk.description);
                document.querySelector('meta[name="keywords"]').setAttribute('content', tdk.keywords);
            },
            listArticles() {
                const vm = this;
                vm.loading = true;

                let info = {
                    'pageNo': 1,
                    'pageSize': 5,
                }
                articleList(info).then(res => {
                    if (res.rows) {
                        let datas = []
                        for (let row of res.rows) {
                            for (let item of row.items) {
                                item.key = item.guid;
                                datas.push(item);
                            }
                        }
                        this.data = datas;
                    }
                }).finally(() => {
                    vm.loading = false;
                })
            },
            treeSections() {
                const vm = this;
                vm.loading = true;

                let info = {
                }
                sectionTree(info).then(res => {
                    if (res.rows) {
                        let datas = [];
                        for (let row of res.rows) {
                            for (let item of row) {
                                if (item.title !== "NEWS") {
                                    continue;
                                }
                                // console.log(item);
                                // datas.push(item);
                                datas = item.children;
                            }
                        }
                        this.treeData.sectionData = datas;
                        // console.log('treeSections', this.treeData);
                    }
                }).finally(() => {
                    vm.loading = false;
                })
            },
            queryArticles() {
                const vm = this;
                vm.loading = true;

                let info = {
                    'pageNo': this.pagination.pageNo,
                    'pageSize': this.pagination.pageSize,
                    'sectionId': this.itemData.sectionId,
                    'status': true,
                }
                this.pagination.total = 0;
                this.data = [];
                queryArticle(info).then(res => {
                    if (res.rows) {
                        let datas = []
                        for (let row of res.rows) {
                            for (let item of row.items) {
                                // console.log(item);
                                if (item.Article.guid === this.itemData.guid) {
                                    continue;
                                }
                                item.Article.key = item.Article.guid;
                                datas.push(item.Article);
                            }
                            this.pagination.total += row.total;
                        }
                        this.data = [...this.data, ...datas];
                        // console.log(info, this.data);
                    }
                }).finally(() => {
                    vm.loading = false;
                })
            },
            detailArticle(info) {
                const vm = this;
                vm.loading = true;

                articleQuery(info).then(res => {
                    if (res.rows) {
                        let datas = []
                        for (let row of res.rows) {
                            for (let item of row.items) {
                                item.key = item.guid;
                                datas.push(item);
                            }
                        }
                        if (datas.length !== 0) {
                            this.itemData = datas[0];
                        } else {
                            this.$router.replace('/404');
                        }
                        console.log(info, this.itemData);

                        let keywords = '';
                        for (let tag of this.itemData.tags) {
                            keywords += tag;
                            keywords += ',';
                        }
                        keywords += this.itemData.name.replaceAll(' ', ',');
                        
                        let tdk = {
                            title: this.itemData.name,
                            description: this.itemData.description,
                            keywords: keywords,
                        }
                        this.configTDK(tdk);

                        // this.listArticles();
                        this.queryArticles();
                    }
                }).finally(() => {
                    vm.loading = false;
                })
            },
            hitArticle(info) {
                const vm = this;
                vm.loading = true;

                articleHit(info).then(res => {
                    if (res.rows) {
                        for (let row of res.rows) {
                            console.log('点击数+1', row);
                        }
                    }
                }).finally(() => {
                    vm.loading = false;
                })
            },
            onSubmit() {
                // console.log('onSubmit', this.form);
                if (this.form.name === '' || this.form.phone === '') {
                    this.submitTips = '请填写您的称呼和电话，这样我们才能联系到您。';
                    this.$nextTick(function() {
                        this.$refs['SUBMIT_TIPS'].style.cssText = "display: block; padding: 10px; font-size: 18px; color: white; background-color: #ff4d4f;";
                    });
                } else {
                    const vm = this;
                    vm.loading = true;

                    let info = {
                        'name': this.form.name,
                        'description': this.form.description,
                        'email': this.form.email,
                        'phone': this.form.phone,
                        'status': false
                    }
                    collectionAdd(info).then(res => {
                        console.log("采集成功");
                        this.submitTips = '您的信息我们已经收到，我们将尽快与您取得联系！';
                        this.$nextTick(function() {
                            this.$refs['SUBMIT_TIPS'].style.cssText = "display: block; padding: 10px; font-size: 18px; color: white; background-color: #70c770;";
                        });
                    }).finally(() => {
                        vm.loading = false;
                    })
                }

                setTimeout(() => {
                    this.submitTips = '';
                    this.$refs['SUBMIT_TIPS'].style.cssText = "display: none;";
                    this.$refs['FORM'].resetFields();
                }, 3000);
            },
            onClickRelated(key) {
                // console.log('-----------查看文章', this.data);
                this.$router.push({
                    path: '/news/detail',
                    query: {
                        articleId: key
                    }
                })
            },
        },
    };
</script>
<style scoped>
    .w {
        position: relative;
    }

    .part1 {
        width: 70%;
        float: left;
    }
    .part1.title {
        padding: 20px 0 30px 0;
        border-bottom: 1px solid rgba(128, 128, 128, 0.1);
        margin-bottom: 20px;
        text-align: left;
    }
    .part1.body {
        line-height: 1.8;
        text-align: left;
    }
    .part1_mobile ::v-deep img {
        display: block;
        width: 100% !important;
        height: 100% !important;
        border-radius: inherit;
        object-position: center center;
        object-fit: cover;
        image-rendering: auto;
    }

    .part2 {
        width: 26%;
        float: left;
        overflow: hidden;
        display: block;
        padding-left: 24px;
        border-left: 1px solid #E8E8E8;
        position: fixed;
        top: 80px;
        right: 0px;
        margin-right: 24px;
    }

    .extra-part1 {
        /* width: 40%;
        float: left; */
        line-height: 2.4;
        /* text-align: center; */
    }
    .extra-part2 {
        /* width: 60%;
        float: left; */
        line-height: 1.8;
        overflow: hidden;
        display: block;
        padding-left: 10px;
        padding-right: 10px;
        /* text-align: center; */
    }

    .concact-card {
        font-size: 24px;
        text-align: center;
    }

    .concact-card .item-card {
        padding: 2rem;
        background: #fafafa;
        border-radius: 4px;
    }

    .concact-form {
        font-size: 24px;
        text-align: center;
    }
    .concact-form .form-card {
        max-width: 520px;
        margin:0 auto;
        padding: 2.6rem;
        background: #fafafa;
        border-radius: 4px;
        border: 1px solid #e8e8e8;
    }

    .list-item-avatar {
        max-width: 72px;
        height: 72px;
        object-fit: cover;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        border-radius: 4px;
    }
    .list-item-title {
        min-height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        /* white-space: nowrap; */
    }
    .list-item-description {
        min-height: 45px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        /* white-space: nowrap; */
    }
    .list-item-tags {
        padding-top: 0px;
    }
    .list-item-time {
        padding-top: 0px;
    }
</style>